'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (date) {
  return _moment2.default.isMoment((0, _moment2.default)(date)) && (0, _moment2.default)(date).toISOString();
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/utils/jsonDate/index.js
// module id = 681
// module chunks = 0